import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

interface OnboardingUpdate {
  zone_city?: string;
  zone_radius_km?: number;
  availability_json?: string;
}

interface OnboardingResponse {
  step: number;
  identity_name?: string;
  zone_city?: string;
  zone_radius_km?: number;
  availability_json?: string;
}

export const onboardingApi = createApi({
  reducerPath: 'onboardingApi',
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_URL ?? '/api/v1',
    credentials: 'include',
  }),
  endpoints: (builder) => ({
    updateOnboardingZone: builder.mutation<OnboardingResponse, { step: number; data: OnboardingUpdate }>({
      query: ({ step, data }) => ({
        url: `/onboarding/${step}`,
        method: 'PATCH',
        body: data,
      }),
    }),
  }),
});

export const { useUpdateOnboardingZoneMutation } = onboardingApi;
